writeFragment